import { ReactNode, useEffect } from 'react';
import { create } from 'zustand';

export interface PageHeaderConfig {
  /** Replaces the nav-derived title. */
  title?: ReactNode;
  /** Muted text beside the title (e.g. what the page is for). */
  subtitle?: ReactNode;
  breadcrumb?: ReactNode;
  /** Page-specific controls shown before the presence avatars and profile. */
  actions?: ReactNode;
}

interface PageHeaderState {
  header: PageHeaderConfig;
  setHeader: (header: PageHeaderConfig) => void;
}

export const usePageHeaderStore = create<PageHeaderState>()(set => ({
  header: {},
  setHeader: header => set({ header }),
}));

/**
 * Let a route fill the shared app header. Memoise the config: a new object on
 * every render would re-render the header every time. Cleared on unmount.
 */
export const usePageHeader = (config: PageHeaderConfig) => {
  const setHeader = usePageHeaderStore(state => state.setHeader);

  useEffect(() => {
    setHeader(config);
  }, [config, setHeader]);

  useEffect(() => () => setHeader({}), [setHeader]);
};
